<template>
  <div class="page">
    <header class="page-header">
      <div class="page-header-bar">绑定终端</div>
      <div class="page-header-content">
        <h1>第四步：绑定成功</h1>
        <p>设备已完成绑定，可继续安装下一台</p>
      </div>
    </header>

    <main class="page-body">
      <div class="page-body-scroll">
        <section class="success-card">
          <div class="success-icon">✓</div>
          <div class="success-title">绑定成功</div>
          <div class="success-desc">设备 {{ terminalCodeText }} 绑定成功</div>
        </section>
      </div>
    </main>

    <footer class="page-footer safe-bottom">
      <van-button block type="primary" @click="continueInstall">继续安装</van-button>
    </footer>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { useMainStore } from '@/store'

const router = useRouter()
const store = useMainStore()
const terminalCodeText = computed(() => store.installSelection.terminalCode || '已完成扫码绑定')

const continueInstall = () => {
  store.setInstallSelection({
    terminalId: null,
    terminalCode: '',
    buildingId: null,
    buildingName: '',
    shaftId: null,
    shaftName: ''
  })
  router.push('/install/location')
}
</script>

<style scoped>
.page {
  display: flex;
  flex-direction: column;
  height: 100dvh;
  overflow: hidden;
  box-sizing: border-box;
  background: #f7f8fa;
  padding-top: calc(env(safe-area-inset-top) + 48px);
}

.page-header {
  flex: none;
  text-align: center;
}

.page-header-bar {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(env(safe-area-inset-top) + 48px);
  padding-top: env(safe-area-inset-top);
  box-sizing: border-box;
  background: #3e87f8;
  color: #fff;
  font-size: 18px;
  font-weight: 600;
}

.page-header-content {
  padding: 16px 0 8px;
}

.page-header h1 {
  margin: 0;
  font-size: 22px;
  line-height: 1.4;
  color: #1f2937;
}

.page-header p {
  margin: 8px 0 0;
  font-size: 14px;
  color: #6b7280;
}

.page-body {
  flex: 1;
  min-height: 0;
  margin: 8px 10px 0;
  padding: 16px;
  overflow: hidden;
  box-sizing: border-box;
  border-radius: 16px;
  background: #eef0f4;
}

.page-body-scroll {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.page-body-scroll::-webkit-scrollbar {
  display: none;
}

.success-card {
  padding: 28px 16px;
  border-radius: 20px;
  background: #fff;
  text-align: center;
}

.success-icon {
  width: 60px;
  height: 60px;
  margin: 0 auto 12px;
  border-radius: 50%;
  background: #34c759;
  color: #fff;
  font-size: 32px;
  line-height: 60px;
}

.success-title {
  font-size: 18px;
  font-weight: 600;
  color: #111827;
}

.success-desc {
  margin-top: 8px;
  font-size: 14px;
  color: #374151;
}

.page-footer {
  flex: none;
  padding: 8px 16px 0;
}

.safe-bottom {
  padding-bottom: calc(env(safe-area-inset-bottom) + 16px);
}
</style>
